export default function header() {
  initStickyHeader();
  hideMenuOnScroll();
  burgerMenuClickHandler();
  checkIfClosestIsHero();
  move_mobile_menu_bottom();
  check_submenu_size_for_styling();
  left_or_right_menu();
}

//Funktion som kollar om det behövs sättas speciell styling på sista barnet i en submeny som är större än sin förälder.
function check_submenu_size_for_styling() {
  const parentMenu = $('.main-menu-desktop .sub-menu').first();
  const parentListCount = $('> li', parentMenu);
  const childMenuCount = $('.sub-menu > li', parentMenu);
  if (childMenuCount >= parentListCount) {
    $('.sub-menu > li:last-child', parentMenu).addClass('last-item-in-larger-sub-menu');
  }

$('.main-menu-container >.menu-item').each(function() {
   let lvl2 = $('>.sub-menu >.menu-item' ,this).length;
   if (lvl2 == 1) {
     $('>.sub-menu' ,this).addClass('only-child');
   }
   $('>.sub-menu >.menu-item' ,this).each(function() {
     let lvl3 = $('>.sub-menu >.menu-item' ,this).length;
     if(lvl3 == 1) {
       $('>.sub-menu' ,this).addClass('only-child');
     }
     if (lvl2 && lvl3) {
       if(lvl2 > lvl3) {
         $('>.sub-menu' ,this).addClass('custom-small');
       }
       else if(lvl2 == lvl3) {
         $('>.sub-menu' ,this).addClass('custom-medium');
       } else {
         $('>.sub-menu' ,this).addClass('custom-large');
       }
     }
   })
  });
}


function move_mobile_menu_bottom() {
  $('#mobile-menu-bottom').appendTo('.mobile-menu-main .mobile-menu');
}

function checkIfClosestIsHero() {
  let id = $('#site-header').next('.page-wrapper').first().find('>:first-child').attr('id');
  if(id) {
    if(id.startsWith('hero-block')) {
      $('.header').addClass('has-hero-block-top');
    }
  }
}

function left_or_right_menu() {
  let width = $(window).width();
  $('.main-menu-desktop .main-menu-container >.menu-item').each(function() {
    let lvl3 = $('>.sub-menu .sub-menu', this).length;
    if(lvl3) {
      $(this).addClass('has-lvl3');
    }
    let element_position = $(this).offset().left;
    let width_lvl1 = $(this).width() / 2;
    let width_lvl2 = $('>.sub-menu', this).width() / 2;
    let width_lvl3 = $('>.sub-menu .sub-menu', this).width();
    let menu_width = width_lvl1 + width_lvl2 + width_lvl3;
    let element_width = element_position + menu_width;
    if(width < element_width) {
      $(this).addClass('menu-to-the-left');
    }
    $(this).addClass('calculated');
  });
}

function burgerMenuClickHandler() {
  $("#burger-menu-open").click(function() {
    $('.burger-menu', this).toggleClass('open');
    $(this).parent().toggleClass('open');
    $('.mobile-menu').toggleClass('show');
    $('.logo').toggleClass('open-mobile-menu');
  });
}

function initStickyHeader() {
  $(window).scroll(function (event) {
    const scroll = $(window).scrollTop();
    const navigation_offset = $('.header').outerHeight();
    if (scroll > navigation_offset) {
      $('.header').addClass('sticky');
    } else {
      $('.header').removeClass('sticky');
    }
  });
}

function hideMenuOnScroll() {
  let doc = document.documentElement;
  let w = window;
  let prevScroll = w.scrollY || doc.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;
  let header = document.getElementById('site-header');
  let checkScroll = function() {
    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      direction = 1;
    }
    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }
    prevScroll = curScroll;
  };
  let toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > 90) {
      header.classList.add('hide');
      prevDirection = direction;
    }
    else if (direction === 1) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
  };
  window.addEventListener('scroll', checkScroll);
}
